var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/stack/stack.tsx";
const _excluded = ["space", "alignItems", "justifyContent", "className", "grow", "element"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
const spaces = {
  0: 'space-y-0',
  [0.5]: 'space-y-0.5',
  1: 'space-y-1',
  [1.5]: 'space-y-1.5',
  2: 'space-y-2',
  3: 'space-y-3',
  4: 'space-y-4',
  5: 'space-y-5',
  10: 'space-y-10'
};
const justifyContentOptions = {
  center: 'justify-center',
  end: 'justify-end'
};
const alignItemsOptions = {
  top: 'items-start',
  bottom: 'items-end',
  center: 'items-center',
  start: 'items-start'
};

/** Vertical stack of child elements. */
const Stack = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    space,
    alignItems,
    justifyContent,
    className,
    grow,
    element = 'div'
  } = props,
        filteredProps = _objectWithoutProperties(props, _excluded);

  const Elem = element;
  return /*#__PURE__*/React.createElement(Elem, _extends({}, filteredProps, {
    ref: ref,
    className: classNames('flex flex-col', {
      // @ts-ignore
      [spaces[space]]: typeof space !== 'undefined',
      // @ts-ignore
      [alignItemsOptions[alignItems]]: typeof alignItems !== 'undefined',
      // @ts-ignore
      [justifyContentOptions[justifyContent]]: typeof justifyContent !== 'undefined',
      'flex-grow': grow
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }));
});
export default Stack;